module.exports = __webpack_public_path__ + "static/media/caret-left.97d603e7.svg";